export function parseJwtPayload(token) {
  if (!token || typeof token !== 'string') {
    return null;
  }
  const parts = token.split('.');
  if (parts.length !== 3) {
    return null;
  }
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

export function getUsernameFromToken(token) {
  const payload = parseJwtPayload(token);
  if (!payload) {
    return null;
  }
  return payload.unique_name || payload.preferred_username || payload.sub || null;
}

export function getProfileIdsFromToken(token) {
  const payload = parseJwtPayload(token);
  if (!payload) {
    return [];
  }
  const profiles = payload.profile ?? payload.profiles ?? [];
  if (Array.isArray(profiles)) {
    return profiles.map(String);
  }
  if (profiles != null) {
    return [String(profiles)];
  }
  return [];
}

export function getModulesFromToken(token) {
  const payload = parseJwtPayload(token);
  if (!payload) {
    return [];
  }

  const modules = payload.modulos ?? payload.modules ?? [];
  if (Array.isArray(modules)) {
    return modules.map((module) => String(module).trim()).filter(Boolean);
  }

  if (typeof modules === 'string') {
    try {
      const parsed = JSON.parse(modules);
      return Array.isArray(parsed)
        ? parsed.map((module) => String(module).trim()).filter(Boolean)
        : [];
    } catch {
      return [];
    }
  }

  return [];
}

export function profilesToLegacyAlumnoCodigos(profileIds) {
  if (!profileIds || profileIds.length === 0) {
    return '';
  }
  if (profileIds.length === 1 && (profileIds[0] === '1' || profileIds[0] === '-1')) {
    return '-1';
  }
  return profileIds.join(',');
}
